import { scrollTable } from "./_scrollTable";
import { accordion } from "./_accordion";
import { animation } from "./_animation";
import { common } from "./_common";
import { drawer } from "./_drawer";
import { slide } from "./_slide";
import { tab } from "./_tab";

scrollTable();
accordion();
animation();
common();
drawer();
slide();
tab();
